!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.accessorFn = t() : e.accessorFn = t();
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, n) {
    var o, r, u;
    !function (n, c) {
      r = [e, t], void 0 !== (u = "function" == typeof (o = c) ? o.apply(t, r) : o) && (e.exports = u);
    }(0, function (e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function (e) {
        return e instanceof Function ? e : "string" == typeof e ? function (t) {
          return t[e];
        } : function (t) {
          return e;
        };
      }, e.exports = t.default;
    });
  }]);
});